import { toast } from "react-toastify";

export const errorHandling = async (error) => {
    if (error?.response?.status == 401) {
        localStorage.removeItem("token");
    }
};

// export const base_api_url = import.meta.env.REACT_APP_API_BASE_URL;

export const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
